import { useEffect } from 'react';

const useWindowSize = (callback) => {
	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 768) {
				callback();
			}
		};

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
};

export default useWindowSize;
